import { TENANT_BILLING_CONFIGURATION_STATUS } from '../billing/billing.interface';
import type { CreateTenantBillingConfiguration, TenantBillingConfiguration } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { billingPlanFactory } from './billing-plan.factory';
import { ObjectFactory } from './object.factory';

/** Stable ObjectId-like id for the default embedded plan snapshot. */
const DEFAULT_PLAN_ID = 'bbbbbbbbbbbbbbbbbbbbbbbb';

export class TenantBillingConfigurationFactory extends ObjectFactory<TenantBillingConfiguration> {
  protected getDefaults(): TenantBillingConfiguration {
    return {
      ...baseDocumentFactory.build(),
      from: new Date('2026-01-01T00:00:00.000Z'),
      overrides: {},
      plan: billingPlanFactory.buildSummary({ id: DEFAULT_PLAN_ID, name: 'standard' }),
      status: TENANT_BILLING_CONFIGURATION_STATUS.ACTIVE,
      to: new Date('2026-12-31T23:59:59.999Z'),
      trialStartedAt: null,
    };
  }

  /** `plan` is resolved server-side from `planId` at creation time — never client-supplied. */
  buildCreate(overrides: Partial<CreateTenantBillingConfiguration> = {}): CreateTenantBillingConfiguration {
    const { planId: planIdOverride, ...buildOverrides } = overrides;
    const { from, overrides: configOverrides, plan, to, trialStartedAt } = this.build(buildOverrides);
    return { from, overrides: configOverrides, planId: planIdOverride ?? plan.id, to, trialStartedAt };
  }
}

export const tenantBillingConfigurationFactory = new TenantBillingConfigurationFactory();
